export default __webpack_public_path__ + "static/media/Series-800-HPX-Inline.36588381.png";